<template>
  <validation-observer ref="faultSupportFileForm">
    <b-form class="formBox">
      <validation-provider
        name="Dosya"
        :rules="{ required: true }"
        v-slot="validationContext"
      >
        <b-form-group class="inputGrp" label="" label-for="file">
          <b-form-file
            multiple
            v-model="files"
            file_id="file"
            placeholder="Dosyayı yükle veya sürükle"
            drop-placeholder="Dosyayı yükle veya sürükle"
            :state="getValidationState(validationContext)"
            aria-describedby="live-feedback"
          ></b-form-file>
          <b-form-invalid-feedback
            subcejtTitle_id="live-feedback"
            class="mt-2 ml-2"
            >{{ validationContext.errors[0] }}</b-form-invalid-feedback
          >
        </b-form-group>
      </validation-provider>
    </b-form>
  </validation-observer>
</template>

<script>
export default {
  name: "FSupportAddImage",
  props: {
    data: Object,
    save: Boolean,
    saveState: Function,
    modalEvent: Function,
    modalName: String,
  },
  data() {
    return {
      files: [],
    };
  },
  watch: {
    save: async function (data) {
      if (data) {
        this.$refs.faultSupportFileForm.validate()
        .then(async (success) => {
          if (success) {
            const image = new FormData()
            this.files.forEach((file) => {
              image.append('image_file', file)
            })

            const reqData = {
              id: this.data.faultSupports.id,
              image_file: image,
            };
            await this.$store.dispatch('addImageToFaultSup', reqData)

            if(this.$store.getters.getStockStatus == 'Success') {
              this.saveState(false);
              this.modalEvent(false);
              if (this.data.faultSupports.isDetailPage) {
                return await this.$store.dispatch('fetchFaultSupportImages', reqData.id)
              }
              return
            }

            this.saveState(false)
          }
        });
      }
    },
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/ERP/Stock/modals/AddImageSupport.vue